import * as yup from 'yup';

export default ({ isFieldMandatory, fieldName, fieldErrorString, defaultString = 'Please select...' }) => {
  if (isFieldMandatory) {
    const FIELD_REQUIRED_ERROR = `jquery.validation.field.required, ${fieldErrorString}`;
    return {
      [fieldName]: yup
          .string()
          .trim()
          .required(FIELD_REQUIRED_ERROR)
          .test(
              fieldName,
              FIELD_REQUIRED_ERROR,
              value => {
                // Check if the value is not the default string
                if (value) {
                  if(Array.isArray(defaultString)) {
                    return !defaultString.includes(value);
                  }else{
                    return value !== defaultString;
                  }
                }
                return false;
              }
          ),
    };
  }
  return {};
};